module.exports = "<div class=\"e404\">\n  <h1>404</h1>\n  <p>Sorry, we failed you, my friend!</p>\n</div>\n"